module.exports = __webpack_public_path__ + "img/39.6739be16.jpg";